// eslint-disable-next-line no-redeclare,import/export
export enum InboxSortOrder {
  MOST_RECENT = 'most_recent_activity',
  OLDEST = 'oldest_activity',
  LONGEST_WAIT_TIME = 'longest_wait_time',
}
